import io from 'socket.io-client/build/esm-debug';
import { device_URI } from '../constants/defaultValues';
import { changeDeviceStatus } from '../store/actions/global';
import { store } from '../store';

const { dispatch } = store;

const deviceSocket = io(device_URI, {
    transports: ['websocket', 'polling'],
    reconnectionDelayMax: 1000,
    forceNew: true,
});

deviceSocket.on('device-status-update', data => {
    dispatch(changeDeviceStatus(data));
});

export default deviceSocket;
